import Button from '@creator/ui/components/Button/ButtonV2';
import Text from '@creator/ui/components/Text/Text';
import React, { type FC, memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

interface ForumPickerButtonProps {
    className?: string;
}

const ForumPickerButton: FC<ForumPickerButtonProps> = props => {
    const { className } = props;

    const { t } = useTranslation();
    const history = useHistory();

    const onClick = useCallback(() => {
        history.push('/bbs/picker');
    }, [history]);

    return (
        <Button className={className} size="sm" variant="ghost" color="base" onClick={onClick}>
            <Text>{t('tokenPageHeader.forumPicker')}</Text>
        </Button>
    );
};

export default memo(ForumPickerButton);
